import React, { type ReactNode } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';

type SummaryInlineEditErrorBoundaryProps = {
	fallback: ReactNode;
	children?: ReactNode;
	packageName: string;
	onError?: () => void;
};

export const SummaryInlineEditErrorBoundary = ({
	fallback,
	children,
	packageName,
	onError,
}: SummaryInlineEditErrorBoundaryProps) => (
	<JSErrorBoundary
		id="summary-inline-edit"
		packageName={packageName}
		teamName="bento"
		fallback={() => <>{fallback}</>}
		onError={onError}
	>
		<Placeholder name="summary-inline-edit-error-boundary" fallback={fallback}>
			{children}
		</Placeholder>
	</JSErrorBoundary>
);
